{
  "list": {
    "title": "Transfers",
    "columns": {
      "number": "Transfer number",
      "direction": "Direction",
      "date": "Date",
      "branch": "Branch",
      "sender": "Sender",
      "receiver": "Receiver",
      "amount": "Transfer amount",
      "commission": "Commission",
      "net": "Net",
      "bankAccount": "Bank account",
      "box": "Box",
      "employee": "Employee",
      "status": "Status"
    },
    "pendingSync": "Awaiting synchronisation",
    "duplicateBadge": "Duplicate reference",
    "filters": {
      "fromDate": "From date",
      "toDate": "To date",
      "branch": "Branch",
      "employee": "Employee",
      "box": "Box",
      "bankAccount": "Bank account",
      "status": "Status",
      "direction": "Direction"
    },
    "rowActions": {
      "trigger": "Actions for transfer {{number}}",
      "viewDetails": "View Details",
      "continueDraft": "Continue transfer"
    },
    "totals": {
      "label": "Totals of posted transfers in the current filter",
      "count": "Transfer count",
      "amount": "Transfer amount",
      "commission": "Commission",
      "net": "Net"
    },
    "exportExcel": "Export to Excel",
    "exportPdf": "Export PDF",
    "exporting": "Exporting...",
    "customerNotPresent": "Customer not present"
  },
  "states": {
    "DRAFT": "Draft",
    "POSTED": "Posted",
    "CANCELLED": "Cancelled"
  },
  "sync": {
    "PENDING": "Awaiting synchronisation",
    "SYNCED": "Synchronised",
    "FAILED": "Sending failed"
  },
  "direction": {
    "BANK_TO_CASH": "Bank to cash",
    "CASH_TO_BANK": "Cash to bank"
  },
  "commissionMode": {
    "DEDUCTED": "Deducted from the amount",
    "ADDED": "Added on top of the amount"
  },
  "details": {
    "back": "Back",
    "notFound": "Transfer not found",
    "sections": {
      "identity": "Transfer",
      "execution": "Branch and execution",
      "amounts": "Amounts",
      "parties": "Parties",
      "evidence": "Evidence",
      "messages": "Messages",
      "prints": "Prints",
      "edits": "Edit history"
    },
    "fields": {
      "number": "Transfer number",
      "date": "Date",
      "status": "Status",
      "direction": "Transfer direction",
      "commissionMode": "Commission method",
      "notes": "Notes",
      "cancelledFrom": "Cancelled from",
      "cancelReason": "Cancellation reason",
      "cancelledBy": "Cancelled by",
      "cancelledAt": "Cancelled at",
      "branch": "Branch",
      "box": "Box",
      "bankAccount": "Bank account",
      "accountNumber": "Account number / IBAN",
      "createdBy": "Created by",
      "createdAt": "Created at",
      "postedBy": "Posted by",
      "postedAt": "Posted at",
      "amount": "Transfer amount",
      "amountCashToBank": "Amount received from the customer",
      "tier": "Tier",
      "tierRange": "From {{from}} to {{to}}",
      "noLimit": "No limit",
      "commission": "Commission",
      "net": "Net cash",
      "netCashToBank": "Amount transferred",
      "receiver": "Receiver",
      "sender": "Sender",
      "senderIsReceiverNote": "Sender is the receiver",
      "fullName": "Full Name",
      "phone": "Phone",
      "documentType": "Document Type",
      "documentNumber": "Document Number",
      "documentCountry": "Issuing Country",
      "documentConflict": "This document belongs to another customer",
      "customerLink": "Customer record",
      "transferReference": "Transfer reference",
      "duplicateReference": "Transfer reference used in another transfer",
      "noReference": "No reference",
      "customerNotPresent": "Customer not present"
    },
    "documentTypes": {
      "NATIONAL_ID": "National ID",
      "PASSPORT": "Passport"
    },
    "signatures": {
      "title": "Signature",
      "signer": "Signed by",
      "signedAt": "Signed at",
      "tablet": "Device",
      "thisDevice": "This device",
      "language": "Language",
      "declaration": "Declaration text",
      "superseded": "Signed on an earlier version",
      "image": "Signature image",
      "imageLoading": "Loading signature...",
      "imageError": "Could not load the signature",
      "none": "No signature"
    },
    "messages": {
      "none": "No messages",
      "templateLabel": "Message type",
      "template": {
        "transfer_paid_recipient": "Recipient payment notice",
        "transfer_paid_sender": "Sender copy",
        "transfer_sent_sender": "Transfer sent notice",
        "transfer_sent_recipient": "Copy to the receiver"
      },
      "status": {
        "PENDING": "Awaiting sending",
        "SENT": "Sent",
        "DELIVERED": "Delivered",
        "FAILED": "Sending failed"
      },
      "phone": "Phone",
      "attempts": "Attempts",
      "sentAt": "Sent at",
      "deliveredAt": "Delivered at",
      "failureReason": "Failure reason"
    },
    "prints": {
      "none": "No prints",
      "first": "First print",
      "reprint": "Reprint",
      "by": "By",
      "at": "At"
    },
    "edits": {
      "none": "No edits",
      "sequence": "Edit #{{sequence}}",
      "reason": "Reason",
      "by": "By",
      "field": "Field",
      "oldValue": "Old value",
      "newValue": "New value",
      "fields": {
        "amount": "Transfer amount",
        "commission": "Commission",
        "net": "Net",
        "tier": "Tier",
        "box": "Box",
        "bankAccount": "Bank account",
        "transferReference": "Transfer reference",
        "senderIsReceiver": "Sender is the receiver",
        "receiverFullName": "Receiver full name",
        "receiverPhone": "Receiver phone",
        "receiverDocumentType": "Receiver document type",
        "receiverDocumentNumber": "Receiver document number",
        "receiverDocumentCountry": "Receiver document issuing country",
        "senderFullName": "Sender full name",
        "senderPhone": "Sender phone",
        "senderDocumentType": "Sender document type",
        "senderDocumentNumber": "Sender document number",
        "senderDocumentCountry": "Sender document issuing country",
        "notes": "Notes"
      }
    },
    "actions": {
      "reprint": "Reprint",
      "resend": "Resend",
      "edit": "Edit",
      "cancel": "Cancel transfer"
    },
    "resend": {
      "confirmTitle": "Confirm resend",
      "confirmDescription": "The messages for transfer {{number}} will be resent.",
      "success": "Messages resent successfully"
    }
  },
  "edit": {
    "drawerTitle": "Edit transfer {{number}}",
    "drawerDescription": "Editing requires a reason and applies immediately to a posted transfer.",
    "fields": {
      "reason": "Edit reason",
      "amount": "Transfer amount",
      "amountAdded": "Amount transferred",
      "commissionModeHint": "Commission method: {{mode}}",
      "box": "Box",
      "bankAccount": "Bank account",
      "transferReference": "Transfer reference",
      "senderIsReceiver": "Sender is the receiver",
      "notes": "Notes",
      "branch": "Branch"
    },
    "receiverSection": "Receiver data",
    "senderSection": "Sender data",
    "preview": {
      "title": "Confirm transfer edit",
      "description": "Review the changes and their effect on balances before saving.",
      "changesTitle": "Changes",
      "effectsTitle": "Effect on balances",
      "commission": "Commission: {{before}} → {{after}}",
      "net": "Net: {{before}} → {{after}}",
      "tier": "Tier: {{before}} → {{after}}",
      "supersedesSignature": "The current signature will become signed on an earlier version.",
      "duplicateReference": "Transfer reference used in another transfer",
      "confirm": "Confirm",
      "back": "Back"
    },
    "updated": "Transfer updated successfully"
  },
  "cancel": {
    "dialogTitle": "Cancel transfer {{number}}",
    "dialogDescription": "The transfer's effect on the box and the bank account will be reversed once.",
    "fields": {
      "reason": "Cancellation reason"
    },
    "commit": "Cancel transfer",
    "cancelled": "Transfer cancelled successfully"
  },
  "signature": {
    "label": "Signature",
    "clear": "Clear",
    "empty": "Not signed yet"
  },
  "drafts": {
    "title": "Draft transfers",
    "description": "Saved transfers that are not approved yet. Open one to complete and approve it.",
    "empty": "There are no draft transfers",
    "continue": "Continue transfer"
  }
}
